// @flow
import { createAction } from 'redux-actions';
import { nextStepAction } from './Section';
import * as types from '../constants/UserData';

export const userDataInitial = createAction(types.USERDATA_INITIAL);
export const userDataInitialAction = (payload) => (dispatch) => (
  dispatch(userDataInitial(payload))
);

// Actions
export const userDataFormSubmit = createAction(types.USERDATA_FORM_SUBMIT);
export const userDataFormSubmitAction = (payload) => (dispatch, getState) => {
  if (typeof payload.setValues === 'function') {
    const state = getState();
    const { userData } = state;
    // Set values for the updated values and price.
    // We use setValues to update the form values back in react.
    payload.setValues({
      ...userData,
      ...payload,
    });
  }
  return dispatch(userDataFormSubmit(payload));
};

export const userDataUpdateLoader = createAction(types.USERDATA_UPDATE_LOADER);
export const userDataUpdateLoaderAction = (payload) => (dispatch, getState) => {
  const result = dispatch(userDataUpdateLoader(payload));

  const state = getState();
  const { userData: { loaderProgress } } = state;

  // Update step if loader is 100% (value of 1). Use 0.99 cos math...
  if (loaderProgress >= 0.98) {
    setTimeout(() => {
      dispatch(nextStepAction());
    }, 200);
  }

  return result;
};

export const userDataResetLoader = createAction(types.USERDATA_RESET_LOADER);
export const userDataResetLoaderAction = (payload) => (dispatch) => (
  dispatch(userDataResetLoader(payload))
);

// Change User Data.
export const userDataChange = createAction(types.USERDATA_CHANGE);
export const userDataChangeAction = (payload) => (dispatch) => {
  dispatch(userDataChange(payload));
};

export const calculationJourney = createAction(types.CALCULATION_JOURNEY_STARTED);
export const calculationJourneyAction = () => dispatch => {
  dispatch(calculationJourney());
};


// WEBPACK FOOTER //
// ./src/actions/UserData.js